/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';
import { AssignmentIcon } from '@coursera/cds-icons';

import { useIntl } from 'bundles/page/lib/useIntl';

import _t from 'i18n!nls/xdp';

type Props = {
  totalQuizzes: number;
  totalAssignments: number;
};

const styles = {
  itemTitle: css`
    padding: var(--cds-spacing-100) 0;
  `,
  icon: css`
    display: block;
  `,
};

const SyllabusContentDetailItem = ({ totalAssignments, totalQuizzes }: Props) => {
  const intl = useIntl();

  if (totalQuizzes === 0 && totalAssignments === 0) {
    return null;
  }

  const assignmentText = intl.formatMessage(
    _t('{totalAssignments, number} {totalAssignments, plural, =1 { assignment} other { assignments}}'),
    {
      totalAssignments,
    }
  );

  const quizText = intl.formatMessage(
    _t('{totalQuizzes, number} {totalQuizzes, plural, =1 { quiz} other { quizzes}}'),
    { totalQuizzes }
  );

  let assignmentAndQuizText;
  if (totalAssignments !== 0 && totalQuizzes !== 0) {
    assignmentAndQuizText = intl.formatMessage(_t('{quizText}, {assignmentText}'), {
      assignmentText,
      quizText,
    });
  } else if (totalAssignments !== 0) {
    assignmentAndQuizText = assignmentText;
  } else {
    assignmentAndQuizText = quizText;
  }

  return (
    <React.Fragment>
      <AssignmentIcon size="large" css={styles.icon} />
      <Typography2 variant="subtitleMedium" css={styles.itemTitle} component="div">
        {_t('Assessments')}
      </Typography2>
      <Typography2 component="p" variant="bodySecondary" color="supportText">
        {assignmentAndQuizText}
      </Typography2>
    </React.Fragment>
  );
};

export default SyllabusContentDetailItem;
